import { useSuspenseQuery } from '@tanstack/react-query'

import { invariant, snakeToCamelCase } from '@marketplace-web/messaging/messaging-util'

import { conversationNew } from '../api'
import { errors } from '../utils'
import { queryClient } from '../query'

export default function useNewConversation(id: string | number) {
  const { data } = useSuspenseQuery(
    {
      retry: false,
      queryKey: [conversationNew.queryKey, id],
      queryFn: () => conversationNew.get(id),
      select: response => {
        invariant(!('errors' in response), new errors.UnexpectedErrorsResponse())

        return snakeToCamelCase(response)
      },
    },
    queryClient,
  )

  return data
}
